import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import Signals from 'signals';
import Vue from 'vue';
import TemplateCommon from '../../../../app/helpers/template-common';
import FormatterCommon from '../../../../app/data-formatters/formatter-common';
import DataService from '../../services/data.service';
import MetadataService from '../../../../services/metadata.service';
import UtilsService from '../../../../services/utils.service';
import FilterModel from '../../components/filter/data/filter.model';
import GridModel from '../../components/grid/data/grid.model';
import GridService from '../../components/grid/data/grid.service';
import topListOptions from '../../dialogs/panel-options/top-list-options/top-list-options';
import VueDatasetService from '../../../../services/vue-dataset-view.service';
import VyTable from '../../../../vueComponents/table/src/table.vue';
import '../../../../app/bindings/tko-bootstrap-multiselect.binding';
import FilterExpressionService from "../../services/filter.expression.service";


    var pageSize = { pageSize: 6 };

    function TopListPanel(params) {
        var self = this;
        self.initialize(params);
    }

    TopListPanel.prototype = {
        getDataSourceByDatasetId: function () {
            var self = this;
            var datasetName = ko.unwrap(ko.unwrap(self.selectedOptions).datasetName);
            var name = _.toLower(datasetName);
            return _.find(self.metadata, function (datasetMetadata) {
                return _.toLower(datasetMetadata.id) === name;
            });
        },



        dispatchShowLoadingIcon: function (show) {
            var self = this;
            UtilsService.dispatchSignal(self.showLoadingIconSignal, show);
        },

        dispose: function () {
            var self = this;
            _.forEach(self.subscriptions, function (subscription) {
                if (typeof subscription.dispose === 'function') {
                    subscription.dispose();
                } else if (typeof subscription.detach === 'function') {
                    subscription.detach();
                }
            });
          if (self.vueTable) {
            self.vueTable.$destroy();
            self.vueTable.$el.parentNode.removeChild(self.vueTable.$el);
          }
        },

        fetchDataset: function (updatedOptions, resetToFirstPage = false) {
            var self = this;

            // if (!_.isNil(self.subscriptions.optionsChanged)) {
            //     self.subscriptions.optionsChanged.dispose();
            // }

            var selectedOptions = ko.unwrap(self.selectedOptions);
            var visibleColumns = ko.observableArray(ko.unwrap(_.get(updatedOptions, 'visibleColumns', selectedOptions.visibleColumns)));
            let dateRangeObj = getDateRangeObj(ko.unwrap(self.dateRangeModel).getCurrentRange());
            self.selectedOptions(
                _.assign(selectedOptions, updatedOptions, { visibleColumns: visibleColumns }, pageSize, dateRangeObj)
            );
            self.filterModel.setActiveFilters(self.selectedOptions().filters);

          // if (VueDatasetService.getLocalFilterFromMetadata(ko.unwrap(self.datasetName), self.metadata)) {
          if (self.filter) {
              self.filter(function(data) {
                return FilterExpressionService.filter(data, self.selectedOptions().filters);
              })
            }
            // self.subscriptions.optionsChanged = self.selectedOptions.subscribe(self.onOptionsChangepad, self);

            if (self.vueTable) {
              resetToFirstPage && !self.noPaginationFromMetadata ? self.vueTable.setFirstPage++ : self.vueTable.reloadData++;
              self.vueTable.shownColumns = ko.unwrap(visibleColumns);
            }
        },

        initialize: function (params) {
            var self = this;
            self.panelId = params?.panelId;
            self.dateRangeModel = params?.dateRange?.();
  
            let signals = params?.signals?.();
        
            self.panelOptionsUpdatedSignal = signals?.panelOptionsUpdated;
            self.showLoadingIconSignal = signals?.showLoadingIcon;
            self.titleChangedSignal = signals?.titleChanged;
            if (!_.isNil(self.titleChangedSignal)) {
              self.titleChangedSignal.add(function(title) {
                var selectedOptions = ko.unwrap(self.selectedOptions);
                self.selectedOptions(_.assign(selectedOptions, { title: title }));
              });
            }

            self.showOptionsSignal = signals?.showOptions;
            if (!_.isNil(self.showOptionsSignal)) {
                self.showOptionsSignal.add(self.onShowOptions.bind(self));
            }

            // //  FIXME: what's this signal for? - 'panel' complains when missing..    :O
            // self.resizeSignal = params.signals.resizeSignal;

            self.vueTableID = 'vueTable-' + UtilsService.generateID();

            self.gridModel = new GridModel();
            self.gridService = new GridService(self.gridModel);
            self.gridReadySignal = new Signals.Signal();

            self.filterReadySignal = new Signals.Signal();
            self.filterModel = new FilterModel();

            self.gridOptions = {
                filterReadySignal: self.filterReadySignal,
                filterModel: self.filterModel,
                gridModel: self.gridModel,
                gridService: self.gridService,
                gridReadySignal: self.gridReadySignal,
            };

            self.selectedOptions = ko.observable(_.assign({}, params.options, pageSize));
            self.columnIdsToHide = ko.observableArray();


            self.datasetName = ko.computed({
                read: function () {
                    return _.get(ko.unwrap(self.selectedOptions), 'datasetName');
                },
                write: _.noop
            }, self);

            self.subscriptions = {};

        },

        koDescendantsComplete: function () {
            var self = this;

            var sortModel = _.get(ko.unwrap(self.selectedOptions), 'sortModel');
            self.gridService.setSorting(sortModel ? sortModel : []);
            self.gridModel.sortingNeedsSave.add(self.saveSortingPreferences.bind(self));

            DataService.fetchMetricsMetadata().then(function (metricMetadata) {
              MetadataService.fetchDatasetMetadataWithoutCategories().then(function (metadata) {
                self.metadata = metadata;

                if (VueDatasetService.getLocalFilterFromMetadata(ko.unwrap(self.datasetName), metadata)) {
                  self.filter = ko.observable();
                }

                var columnIdsToShow = ko.unwrap(ko.unwrap(self.selectedOptions).visibleColumns);
                var metadataColumnIds = _.map(self.getDataSourceByDatasetId().columns, 'id');
                var columnIdsToHide = (columnIdsToShow && columnIdsToShow.length) ? _.difference(
                    metadataColumnIds, columnIdsToShow) : [];

                self.columnIdsToHide(columnIdsToHide);
                self.gridService.setHiddenHeaders(columnIdsToHide);

                let columns = VueDatasetService.getColumnsFromMetadata(ko.unwrap(self.datasetName),
                    metadata, true);
                if (sortModel && sortModel.length) {
                  columns = VueDatasetService.addSortingToColumns(columns, sortModel);
                }
                let dataIndex = VueDatasetService.getDataIndexFromMetadata(
                    ko.unwrap(self.datasetName), metadata);
                let persistenceID = `vyopta_cpmm_panel_${ko.unwrap(self.panelId)}`;
                // TODO: load preferences and check if payload contains a column configuration and set the corresponding localStorage value
                //let localStorageKey = `tabulator-${persistenceID}-columns;
                let reloadData = 0;
                let setFirstPage = 0;

                self.noPaginationFromMetadata = VueDatasetService.getNoPaginationFromMetadata(ko.unwrap(self.datasetName), metadata);
                let autoFetchConfig = {
                  url: 'fakeurl', // tabulator needs a url config to trigger the ajaxRequestFunc
                  localSort: VueDatasetService.getLocalSortFromMetadata(ko.unwrap(self.datasetName), metadata),
                  noPagination: self.noPaginationFromMetadata,
                  ajaxRequestFunc: function (url, config, tableParams) {
                    return new Promise((resolve, reject) => {
                      let requestParams = Object.assign({}, tableParams, {
                        size: self.selectedOptions().pageSize,
                        start: self.selectedOptions().startDate
                            || UtilsService.convertMomentToUtcAndFormatServerReady(
                                moment().subtract(1, 'hour')),
                        end: self.selectedOptions().endDate
                            || UtilsService.convertMomentToUtcAndFormatServerReady(moment()),
                        filter: self.filterModel.getActiveFiltersString()
                      });

                      // convert from 1-index to 0-index pagination
                      if (requestParams.page) {
                        requestParams.page = requestParams.page - 1;
                      } else {
                        requestParams.page = 0;
                      }

                      if (requestParams.sorters && requestParams.sorters.length) {
                        requestParams.sort = VueDatasetService.getSortParam(requestParams.sorters);
                        delete requestParams.sorters;
                      }

                      VueDatasetService.getDataset(ko.unwrap(self.datasetName), requestParams).then(
                          data => {
                            if (! data) {
                                console.log("getDataset API call missing response data");
                                return;
                            }
                            let safeData = [];
                            if (data.content && data.content.length > 0) {
                              safeData = data.content.map(function (row) {
                                return FormatterCommon.sanitize(row);
                              });
                            }

                            resolve(self.noPaginationFromMetadata ? safeData :
                              {
                                last_page: data.totalPages,
                                data: safeData
                              });

                            self.dispatchShowLoadingIcon(false);
                          });
                    });
                  }
                }

                self.vueTable = new Vue({
                  el: '#' + self.vueTableID,
                  data: function () {
                    return {
                      componentKey: 0,
                      columns,
                      tableData: [],
                      filter: ko.unwrap(self.filter),
                      pageSize: self.selectedOptions().pageSize,
                      autoFetchConfig,
                      showEdit: false,
                      persistenceID,
                      dataIndex,
                      reloadData,
                      setFirstPage,
                      shownColumns: columnIdsToShow,
                      tableId: self.vueTableID,
                    };
                  },
                  methods: {
                    handleSortChange: function (sorters) {
                      let sortModel = sorters.map(sorter => {
                        return {
                          colId: sorter.field,
                          sort: sorter.dir
                        }
                      });
                      if (!_.isEqual(self.gridService.getSorting(), sortModel)) {
                        // TODO: is it safe to remove all the gridModel and gridService code?
                        self.gridService.setSorting(sortModel ? sortModel : []);
                        self.saveSortingPreferences();
                      }
                    },
                    handlePersistenceUpdated: function (id, type, data) {
                      // TODO: Save to prefs here
                    }
                  },
                  render(h) {
                    return h('div', { class: 'top-list-content-div' }, [
                      h(VyTable, {
                        ref: this.tableId,
                        key: this.componentKey,
                        props: {
                          columns: this.columns,
                          dataIndex: this.dataIndex,
                          tableData: this.tableData,
                          filter: this.filter,
                          persistenceID: this.persistenceID,
                          autoFetchConfig: this.autoFetchConfig,
                          reloadData: this.reloadData,
                          setFirstPage: this.setFirstPage,
                          shownColumns: this.shownColumns,
                          showEdit: this.showEdit,
                          pageSize: this.pageSize,
                        },
                        on: {
                          'table-sorted': this.handleSortChange,
                          'table-persistence-updated': this.handlePersistenceUpdated,
                        }
                      })
                    ]);
                  }
                });

                if (self.filter) {
                  self.subscriptions.filter = self.filter.subscribe(newFilter => {
                    self.vueTable.filter = newFilter;
                  });
                }

                self.dispatchShowLoadingIcon(true);
                self.fetchDataset(ko.unwrap(self.selectedOptions));

                self.gridService.setupComplete();

                self.subscriptions.dateRange = self.dateRangeModel.currentRangeUpdated.add(function () {
                  self.fetchDataset(ko.unwrap(self.selectedOptions), true); // true means set the dataset to page 1
                }, self);
              });
            });
        },

        onOptionsChanged: function (updatedOptions) {
            var self = this;
            var title = updatedOptions.params.title;

            var panelId = ko.unwrap(self.panelId);
            var updatedPanelOptions = _.assign({},
                updatedOptions.panel,
                {
                    id: panelId,
                    params: {
                        options: updatedOptions.params
                    }
                }
            );

            UtilsService.dispatchSignal(self.titleChangedSignal, title);
            UtilsService.dispatchSignal(self.panelOptionsUpdatedSignal, updatedPanelOptions);

          self.selectedOptions(
              _.assign(ko.unwrap(self.selectedOptions), updatedOptions.params)
          );


          if (self.oldDatasetName !== ko.unwrap(self.datasetName)) {
            if (self.subscriptions.filter) self.subscriptions.filter.dispose();

            let localSortFromMetadata = VueDatasetService.getLocalSortFromMetadata(ko.unwrap(self.datasetName), self.metadata);
            if (localSortFromMetadata) {
              self.filter = ko.observable();
            } else {
              self.filter = undefined;
            }
            if (self.filter) {
              self.subscriptions.filter = self.filter.subscribe(newFilter => {
                self.vueTable.filter = newFilter;
              });
            }

            // do something with sortModel
            var sortModel = _.get(updatedOptions, 'sortModel');
            self.gridService.setSorting(sortModel ? sortModel : []);

            // something about filter
            self.filterModel.setActiveFilters(self.selectedOptions().filters);

            // todo do something with persistenceID??

            self.vueTable.autoFetchConfig.localSort = localSortFromMetadata;
            self.noPaginationFromMetadata = VueDatasetService.getNoPaginationFromMetadata(ko.unwrap(self.datasetName), self.metadata)
            self.vueTable.autoFetchConfig.noPagination = self.noPaginationFromMetadata;

            let columns = VueDatasetService.getColumnsFromMetadata(ko.unwrap(self.datasetName), self.metadata, true);
            if (sortModel && sortModel.length) {
              columns = VueDatasetService.addSortingToColumns(columns, sortModel);
            }
            self.vueTable.columns = columns;
            self.vueTable.filter = ko.unwrap(self.filter);

            //  something about visibleColumns
            self.vueTable.shownColumns = ko.unwrap(self.selectedOptions).visibleColumns;

            // destroy and rebuild table component
            self.vueTable.componentKey += 1;
          } else {
            self.fetchDataset(updatedPanelOptions.params.options, true);
          }
          self.oldDatasetName = ko.unwrap(self.datasetName());


        },

        saveSortingPreferences:  function () {
            var self = this;
            var panelId = ko.unwrap(self.panelId);
            var updatedPanelOptions = { id: panelId,
                    params: {
                        options: {
                            sortModel: self.gridService.getSorting()
                        }
                    }
                };
            UtilsService.dispatchSignal(self.panelOptionsUpdatedSignal, updatedPanelOptions);
        },

        onShowOptions: function () {
            var self = this;
            self.oldDatasetName = ko.unwrap(self.datasetName);

            topListOptions
                .dialog({
                    metadata: self.metadata,
                    selections: _.cloneDeep(ko.unwrap(self.selectedOptions))
                })
                .then(function (selectedOptions) {
                    if (!_.isEmpty(selectedOptions)) {

                        var columnIdsToShow = _.get(selectedOptions, 'params.visibleColumns');
                        var metadataColumnIds = _.map(self.getDataSourceByDatasetId().columns, 'id');
                        var columnIdsToHide = (columnIdsToShow && columnIdsToShow.length) ? _.difference(metadataColumnIds, columnIdsToShow) : [];
                        self.columnIdsToHide(columnIdsToHide);
                        self.gridService.setHiddenHeaders(columnIdsToHide, true);

                        self.onOptionsChanged(selectedOptions);
                    }
                })
                .catch(function (error) {
                  // do we need to do anything on cancel?
                });
        }
    };

    function getDateRangeObj(dateRange) {
        return {
            startDate: UtilsService.convertMomentToUtcAndFormatServerReady(dateRange.startDate),
            endDate: UtilsService.convertMomentToUtcAndFormatServerReady(dateRange.endDate)
        };
    }

    export default TopListPanel;
